import { render, staticRenderFns } from "./IconExcel.vue?vue&type=template&id=78a91022&scoped=true&"
import script from "./IconExcel.vue?vue&type=script&lang=ts&"
export * from "./IconExcel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a91022",
  null
  
)

export default component.exports